import { BaseGraphicsProvider } from "elements/base/graphics";
import { ResizeType } from "elements/base/types";
import { MondayTaskElement } from "./schema";
import { StandardAnchorPoints } from "frontend/canvas-designer-new/elements/connector/anchor-point-utils";
import { CanvasElementBox, Degrees } from "utils/transform";
import { MONDAY_TASK_WIDTH, MONDAY_TASK_BASE_HEIGHT } from "shared/datamodel/monday-task";
import { BORDER_HEIGHT } from "./consts";

export default class MondayTaskGraphicsProvider extends BaseGraphicsProvider<MondayTaskElement> {
  getConnectorAnchorPoints(element: MondayTaskElement): StandardAnchorPoints | null {
    const { x, y, width = MONDAY_TASK_WIDTH, height = MONDAY_TASK_BASE_HEIGHT, scaleX = 1, scaleY = 1 } = element;
    const scaledWidth = width * scaleX;
    const scaledHeight = height * scaleY;

    const anchors = {
      top: { x: x + scaledWidth / 2, y, rotation: 270 as Degrees, onBoundingBox: true },
      right: { x: x + scaledWidth, y: y + scaledHeight / 2, rotation: 0 as Degrees, onBoundingBox: true },
      buttom: {
        x: x + scaledWidth / 2,
        y: y + scaledHeight + BORDER_HEIGHT,
        rotation: 90 as Degrees,
        onBoundingBox: true,
      },
      left: { x, y: y + scaledHeight / 2, rotation: 180 as Degrees, onBoundingBox: true },
    };
    return anchors;
  }

  getResizeType(): ResizeType {
    return ResizeType.Corners;
  }

  getTransformParams(element: MondayTaskElement): CanvasElementBox {
    // We take into account the border for the total bounding box height
    const borderHeight = 5;

    return {
      x: element.x,
      y: element.y,
      width: element.width * (element.scaleX ?? 1),
      height: (element.height + borderHeight) * (element.scaleY ?? 1),
    };
  }
}
